import React, { useState } from 'react';
import { Box, IconButton, Button, Grid } from '@mui/material';
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import Spacer from '../Spacer';

interface CollapsibleBoxProps {
    title: string;
    children: React.ReactNode;
    defaultOpen?: boolean;
}

const CollapsibleBox: React.FC<CollapsibleBoxProps> = ({ title, children, defaultOpen = false }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    const theme = useTheme();

    return (
        <Box sx={{
            border: '1px solid #EEEEEE',
            padding: theme.spacing(1),
            width: '100%',
            borderRadius: theme.spacing(1),
            backgroundColor: theme.palette.background.paper,
        }}>
            <div>
                <IconButton
                    onClick={() => setIsOpen(!isOpen)}
                    className="collapsible-cell-button"
                    sx={{ color: theme.palette.primary.main }}
                >
                    {isOpen ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
                <Button onClick={() => setIsOpen(!isOpen)}>{title}</Button>
            </div>
            {isOpen && (
                <>
                    <Spacer size="two" vertical />
                    <Grid container spacing={2}>
                        {children}
                    </Grid>
                </>
            )}
        </Box>
    );
};

export default CollapsibleBox; 